import { getFirestore } from "firebase/firestore";

import firebaseApp from "../lib/firebaseApp";

export const getFirebaseFirestore = () => getFirestore(firebaseApp);

export const getFirebaseFirestoreWithDB = (databaseId: string) => getFirestore(firebaseApp, databaseId);
